export class DashboardAdvogado {
  totalClientes: number;
  totalClientesUltimoLogin: number;
  totalTarefasAgendadasHoje: number;
  totalAtendimentosContatoInicialHoje: number;
  totalAtendimentosAgendadoHoje: number;
}
